'use strict';

const baseChainLevels = {
  PR: 'Prisma',
  SM: 'S-Market',
  PM: 'Sale / Alepa',
};

const hasuChainLevels = {
  ...baseChainLevels,
  ABC: 'ABC',
  HERKKU: 'Herkku',
};

const aocChainLevels = {
  ...baseChainLevels,
  ...hasuChainLevels,
};

const integrationChainLevels = {
  ...baseChainLevels,
  AB: 'AB',
};

const workpackageSetupChainLevels = [...Object.keys(baseChainLevels), 'CFC', 'AB'];

// The chain values used in the wp setup are different to the ones in extract
// This conversion is for compatibility
// The AB conversion step should be removed by AOV3-7678
// However, CFC should map back to PR once leaving the tool.
const wpToExtractChainMapping = {
  AB: 'ABC',
  CFC: 'PR',
};

module.exports = {
  baseChainLevels,
  hasuChainLevels,
  aocChainLevels,
  integrationChainLevels,
  workpackageSetupChainLevels,
  wpToExtractChainMapping,
};
